<!--地图组件-->
<template>
  <div class="filter_wrap">
    <div class="filter_div">
      <el-scrollbar style="height:100%;">
        <div class="filter_title">勾选显示对象</div>
        <el-checkbox-group v-model="checkedLayers" @change="handleCheckedLayerChange">
          <el-checkbox v-for="layer in layers" :label="layer.id" :key="layer.id" >{{ layer.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import * as Cesium from 'cesium';
import BuildingLayer from './layer/buildingLayer';
import WorkerLayer from './layer/workerLayer';
import VehicleLayer from './layer/vehicleLayer';
import RiskAreaLayer from './layer/riskAreaLayer';
import CameraLayer from './layer/cameraLayer';
import AlarmLayer from './layer/alarmLayer';
import DeviceLayer from './layer/deviceLayer';
import DangerLayer from './layer/dangerLayer';
import StoreLayer from './layer/storeLayer';
import CPVGasLayer from './layer/cpvGasLayer';
import EXGasLayer from './layer/exGasLayer';
import TrackLayer from './layer/trackLayer';
import WorkPermitLayer from './layer/workPermitLayer';
import CONSTANTS from "./constants";
import MapUtil from './utils/mapUtil';
import * as Api from "@/api/api";
import {mapMutations} from "vuex"

let workerLayer;
export default {
  name: 'layerControl',
  computed:{
  },
  components: {
  },
  data(){
    return {
      checkedLayers:[],
      layers:[
        {id:CONSTANTS.LAYER.WORKPERMIT,name:"作业票",checked:false},
        {id:CONSTANTS.LAYER.DANGER,name:"重大危险源",checked:false},
        {id:CONSTANTS.LAYER.RISKAREA,name:"风险区域",checked:true},
        {id:CONSTANTS.LAYER.DEVICE,name:"设备装置",checked:false},
        {id:CONSTANTS.LAYER.CAMERA,name:"监控探头",checked:false},
        {id:CONSTANTS.LAYER.WORKER,name:"人员",checked:true},
        {id:CONSTANTS.LAYER.VEHICLE,name:"车辆",checked:false},
        {id:CONSTANTS.LAYER.CPVGAS,name:"有毒气体",checked:false},
        {id:CONSTANTS.LAYER.EXGAS,name:"可燃气体",checked:false},
        {id:CONSTANTS.LAYER.STORE,name:"仓库物资",checked:false},
        {id:CONSTANTS.LAYER.ALARM,name:"报警",checked:false}
      ],
      overLayers:[CONSTANTS.LAYER.WORKER,CONSTANTS.LAYER.VEHICLE,CONSTANTS.LAYER.WORKPERMIT],//点击冒泡图层:
      detailBoxLayers:[
        CONSTANTS.LAYER.WORKPERMIT,
        CONSTANTS.LAYER.RISKAREA,
        CONSTANTS.LAYER.CAMERA,
        CONSTANTS.LAYER.DEVICE,
        CONSTANTS.LAYER.DANGER,
        CONSTANTS.LAYER.EXGAS,
        CONSTANTS.LAYER.CPVGAS
      ],//点击显示右边详情框图层:作业票、风险区域、监控探头,设备,重大危险源,可燃气体,有毒气体
    }
  },
  props:{
  },
  mounted(){
    let self=this;
    //建筑物图层
    this.buildingLayer =new BuildingLayer();
    Api.getBuildingList().then(res => {
      if (res.data.status_code === 100) {
        this.buildingLayer.addEntities(res.data.data);
      }
    })

    //风险区域图层
    this.riskAreaLayer = new RiskAreaLayer();
    Api.getRiskPointList({limit: 10000, curPage: 1}).then(res => {
      if (res.data.status_code === 100) {
        this.riskAreaLayer.addEntities(res.data.data);
        this.setRiskAreaList(res.data.data);
      }
    })

    //报警图层
    this.alarmLayer = new AlarmLayer();
    this.getWarnData();

    //摄像头图层
    this.cameraLayer = new CameraLayer();
    //this.cameraLayer.addEntities(this.getRandomData("摄像头",5));
    Api.getCameraList().then(res => {
      if (res.data.status_code === 100) {
        this.cameraLayer.addEntities(res.data.data);
      }
    });

    //作业票图层
    this.workPermitLayer = new WorkPermitLayer();
    //this.workPermitLayer.addEntities(this.getRandomData("workerOrder",5));
    Api.getWorkPermitList().then(res => {
      if(res.data.status_code === 100) {
        this.workPermitLayer.addEntities(res.data.data);
      }
    })

    //员工图层
    workerLayer = new WorkerLayer();
    this.$nextTick(() => {
      this.getAllWorker()
    })
    //车辆图层
    this.vehicleLayer = new VehicleLayer();
    //this.vehicleLayer.addEntities(this.getRandomData("货车",5));
    Api.getVehicleList().then(res => {
      if (res.data.status_code === 100) {
        this.vehicleLayer.addEntities(res.data.data);
      }
    })

    //设备图层
    this.deviceLayer = new DeviceLayer();
    //this.deviceLayer.addEntities(this.getRandomData("设备",5));
    Api.getDeviceList().then(res => {
      if (res.data.status_code === 100) {
        this.deviceLayer.addEntities(res.data.data);
      }
    })
    //重大危险源图层
    this.dangerLayer=new DangerLayer();
    //this.dangerLayer.addEntities(this.getRandomData("危险源",5));
    Api.getDangerList().then(res => {
      if (res.data.status_code === 100) {
        this.dangerLayer.addEntities(res.data.data);
      }
    })
    //仓库物资图层
    this.storeLayer=new StoreLayer();
    //this.storeLayer.addEntities(this.getRandomData("仓库",5));
    Api.getStoreList().then(res => {
      if (res.data.status_code === 100) {
        this.storeLayer.addEntities(res.data.data);
      }
    })
    //有毒气体图层
    this.cpvGasLayer=new CPVGasLayer();
    //this.cpvGasLayer.addEntities(this.getRandomData("有毒气体",5));
    //可燃气体图层
    this.exGasLayer=new EXGasLayer();
    //this.exGasLayer.addEntities(this.getRandomData("可燃气体",5));
    Api.getHarmList().then(res => {
      if (res.data.status_code === 100) {
        this.cpvGasLayer.addEntities(res.data.data);
        this.exGasLayer.addEntities(res.data.data);
      }
    })
    //轨迹图层
    this.trackLayer=new TrackLayer();

    //每6s获取人员与车辆位置信息
    this.interval=setInterval(() => {
      MapUtil.closeOverlay();
      this.getAllWorker();
    }, 6000);

    //图层显示处理
    for(let item of this.layers){
      let layer=MapUtil.getLayerByName(item.id);
      if(layer){
        layer.setVisible(item.checked);
      }
      item.checked&&this.checkedLayers.push(item.id);
    }

    //TODO:处理报警
    window.EventCenter.on('handlerWarn', (data) => {
      console.log(data);
      this.$confirm('此操作将确认该报警, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api.doTXZKWarn(data.remark,data.cardId,data.createTime).then(res=>{
          if(res.data.code ==200){
            this.getWarnData();
            this.$message({
              type: 'success',
              message: '确认成功!'
            });
          }else{
            this.$message({
              type: 'warning',
              message: '系统未知错误,请反馈给管理员!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认'
        });
      });
    });

  },
  methods:{
    ...mapMutations([
      'setOnlineUserCount',
      'setWarnList',
      'setRiskAreaList'
    ]),
    /**
     * 控制图层
     * @param val
     */
    handleCheckedLayerChange(val) {
      console.log(val);
      for (let item of this.layers) {
        let layer = MapUtil.getLayerByName(item.id);
        if (layer) {
          layer.setVisible(val.includes(item.id));
        }
      }
    },

    getAllWorker(){
      if(workerLayer.getVisible()){
        Api.getAllWorker().then(res => {
          if (res.data.code === 200) {
            workerLayer.updateEntities(res.data.data)
            this.setOnlineUserCount(res.data.data.length)
          }
        })
      }
    },

    /**
     * 获取报警列表数据
     */
    getWarnData(){
      Api.getTXZKWarnData().then((res)=>{
        this.alarmLayer.addEntities((res.data.rows))
        this.setWarnList(JSON.parse(JSON.stringify(res.data.rows)))
      })
    },

    activate(drawType){
      this.drawTool.activate(drawType,(data)=>{
        console.log(data);
      });
    },

    clearAll(){
      this.drawTool.clearAll();
    },

    getRandomData(type,length){

      let points=[];
      for(let i=0;i<length;i++){
        points.push({id:i,name:type+"00"+i,factor:0,cerType:Math.floor(Math.random() * 4+ 1),type:type,longitude:this.initPosition.longitude+Math.random()*0.001*(Math.random()>0.5?1:-1),latitude:this.initPosition.latitude+Math.random()*0.0005*(Math.random()>0.5?1:-1)});
      }
      return points;
    },
    changeLayer(layerName){
      let layer=MapUtil.getLayerByName(layerName);
      if(layer){
        layer.setVisible(!layer.getVisible());
      }
    },
  },
  beforeDestroy() {
    this.alarmLayer&& this.alarmLayer.destroy();
    //this.eleFenceLayer&& this.eleFenceLayer.destroy();
    this.cameraLayer&& this.cameraLayer.destroy();
    this.workPermitLayer&& this.workPermitLayer.destroy();
    //this.workerLayer&& this.workerLayer.destroy();
    this.vehicleLayer&& this.vehicleLayer.destroy();
    this.deviceLayer&& this.deviceLayer.destroy();
    this.dangerLayer&& this.dangerLayer.destroy();
    this.storeLayer&& this.storeLayer.destroy();
    this.cpvGasLayer&& this.cpvGasLayer.destroy();
    this.exGasLayer&& this.exGasLayer.destroy();
    this.isInitComplete=false;
    window.EventCenter.removeListener('openTrack', () => { });//解除监听
    window.EventCenter.removeListener('closeTrack', () => { });//解除监听
    window.EventCenter.removeListener('handlerWarn', () => { });//解除监听
    this.interval&&window.clearInterval(this.interval);
  }
}
</script>
<style scoped>
.filter_wrap {
  opacity: 1;
  position: fixed;
  bottom: 18vh;
  left: 52ch;
  z-index: 999;
  max-height: calc(100vh - 8.75rem);
  min-width: 7.5rem;
  top: unset;
}
.filter_div{
  background: rgba(6,28,50,.7);
  z-index: 10;
  border: 1px solid rgba(0,153,255,.4);
  border-radius: 2px;
  -webkit-box-shadow: 5px 5px 25px rgb(0 0 0 / 40%);
  box-shadow: 5px 5px 25px rgb(0 0 0 / 40%);
  max-height: calc(100vh - 11.25rem);
  max-width: 8rem;
}
.filter_title{
  font-size: 1rem;
  color: #fff;
  padding-left: 8px;
  padding-top: 3px;
  font-weight: 700;
}
.filter_div_show{
  margin-top: 5px;
  padding: 0 8px;
  height: 1.75rem;
  line-height: 1.75rem;
  text-align: center;
}
.el-checkbox{
  color: #fff;
}

</style>
